export default "__VITE_ASSET__CzOlcukh__"